module.exports = __webpack_public_path__ + "static/media/handshake.61bba2d0.svg";